import { LanguageService } from './../service/language.service';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { SettingService } from '../service/setting.service';
import { PanelBarStateChangeEvent } from '@progress/kendo-angular-layout';
import { AuthenticationService } from '../authentication/authentication.service';

@Component({
  selector: 'app-help',
  templateUrl: './help.component.html',
  styleUrls: ['./help.component.scss']
})
export class HelpComponent implements OnInit
{
  public language: string;
  public selectedItem: string = null;
  public patientLabel = {};
  public communityEnabled = false;
  public isDirectoryManager = false;
  public isShowHelp = false;

  constructor(
    private authService: AuthenticationService,
    private languageService: LanguageService,
    private route: ActivatedRoute,
    private settingService: SettingService
  )
  {
    this.selectedItem = 'documents'; // Set first option as default
    this.route.queryParams.subscribe({
      next: (params) =>
      {
        if (params && params.topic)
        {
          this.selectedItem = params.topic;
        }
      }
    });
  }

  public ngOnInit(): void
  {
    this.isShowHelp = (this.authService.currentUser.role === 'ROLE_OPERATOR' || this.authService.currentUser.role === 'ROLE_PROGRAM_LEAD');
    this.isDirectoryManager = (this.authService.currentUser.role === 'ROLE_DIRECTORY_MANAGER');
    this.language = this.languageService.currentLanguage;
    this.settingService.getCachedSessionSettings().subscribe({
      next: (sessionSetting) =>
      {
        this.patientLabel = { patientLabel: sessionSetting.patientLabel };
        this.communityEnabled = sessionSetting.communityEnabled;
      }
    });
  }

  /**
   * Help Panel State Change event.
   *
   * @param data Panel data item.
   */
  public stateChange(data: PanelBarStateChangeEvent): boolean
  {
    const selected = data.items.filter(x => x.selected);
    if (selected)
    {
      this.selectedItem = selected[0].id;
    }
    else
    {
      this.selectedItem = null;
    }
    return true;
  }
}
